import React from "react";
import "./TestimonialCard.css";

interface TestimonialCardProps {
  quote: string;
  name: string;
  role: string;
  company: string;
  image?: string;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  quote,
  name,
  role,
  company,
  image,
}) => {
  return (
    <div className="testimonial-card no-hover">
      <p className="quote">“{quote}”</p>
      <div className="author">
        {image && <img src={image} alt={name} className="author-img" />}
        <div>
          <h4>{name}</h4>
          <p>
            {role} <br /> <span>{company}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
